import Logger from '../logger';
import event from '../mixins/event';
import simpleParallax from 'simple-parallax-js';

class SideImageHero {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'SideImageHero';

		this.dom = dom;

		this.parallaxImages = this.dom.querySelectorAll(`[data-side-image-hero-image]`);

	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initParallax();
	}

	/**
	 * initParallax - Initialize the parallax effect
	 */
	initParallax() {
		Logger.info(`${this.NAME} > initParallax`);

		if (!this.parallaxImages) return;

		new simpleParallax(this.parallaxImages, {
			delay: .6,
			orientation: 'down',
			scale: 1.3
		});

	}

}

Object.assign(SideImageHero.prototype, event);

export default SideImageHero;
